import axios from "axios";
import React, { useState, useEffect } from "react";
import { putApi } from "../AppApis";
import { toast } from "react-toastify";

export default function InputForms({ setIsDynamicFieldsShow, property }) {
    const [formData, setFormData] = useState(null);
    const [formErrors, setFormErrors] = useState({});
    const [formJsonData, setFormJsonData] = useState(null);
    const [searchTerms, setSearchTerms] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    // Debug: Log property to see its structure
    console.log("Property received in InputForms:", property);
    console.log("Property listing_info:", property?.listing_info);
    console.log("Property listing_data:", property?.listing_info?.listing_data);

    const getstate = () => {
        if (!property) return "MN"; // default fallback
        const state = property.state || property.StateOrProvince || "";
        if (state.includes("MN") || state.includes("Minnesota")) {
            return "MN";
        } else if (state.includes("FL") || state.includes("Florida")) {
            return "FL";
        } else if (state.includes("NC") || state.includes("North Carolina")) {
            return "NC";
        } else {
            return "MN";
        }
    };

    const getPropertyType = () => {
        if (!property) return "single_family_residential"; // default fallback
        if (property.PropertySubType === "Single_Family") {
            return "single_family_residential";
        } else if (property.PropertySubType === "Condo") {
            return "condo_townhome";
        } else if (property.PropertySubType === "Townhouse") {
            return "lots_acres_farm";
        } else {
            return "multi_family_residential";
        }
    };
    useEffect(() => {
        // Don't fetch if property is missing
        if (!property) {
            setIsLoading(false);
            setError("Property data is not available.");
            return;
        }

        const payload = {
            state: getstate(),
            city: property.City || property.city || "",
            zip: property.PostalCode || property.zip || "",
            property_type: getPropertyType(),
        };
        const fetchData = async () => {
            try {
                setIsLoading(true);
                setError(null);

                const response = await axios.post("https://admin.onmls.com/property/field-schema", payload, {
                    headers: {
                        "Content-Type": "application/json",
                        "X-Webhook-API-Key": "yry932bdwywe62rh282u2hhr4234",
                    },
                });
                console.log("API response:", response);

                // Check for response data structure
                const responseData = response.data || response;
                if (responseData && responseData.fields) {
                    setFormJsonData(responseData.fields);
                } else if (responseData && Array.isArray(responseData)) {
                    // Handle case where response is directly an array
                    setFormJsonData(responseData);
                } else {
                    console.error("Unexpected API response structure:", responseData);
                    // Set empty array to show "No dynamic fields available" message
                    setFormJsonData([]);
                }
            } catch (error) {
                console.error("Error fetching dynamic fields:", error);
                setError("Failed to load dynamic fields. Please try again later.");
                // Set empty array to prevent infinite loading
                setFormJsonData([]);
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (!formJsonData) {
            return;
        }
        const initialData = {};

        // Extract listing_data from property if it exists
        // Try multiple possible paths for the listing data
        const existingListingData = property?.listing_info?.listing_data || property?.listing_data || property?.listingInfo?.listingData || {};
        console.log("Existing listing data from property:", existingListingData);

        // If existingListingData is a string (JSON), parse it
        let parsedListingData = existingListingData;
        if (typeof existingListingData === "string") {
            try {
                parsedListingData = JSON.parse(existingListingData);
                console.log("Parsed listing data:", parsedListingData);
            } catch (e) {
                console.error("Failed to parse listing data:", e);
                parsedListingData = {};
            }
        }

        formJsonData.forEach((section) => {
            console.log("section", section);
            const sectionData = parsedListingData[section.name] || {};

            (section?.fields ?? section?.sections)?.forEach((field) => {
                // Check if we have existing data for this field
                const existingValue = sectionData[field.label];

                if (existingValue !== undefined && existingValue !== null) {
                    // Use existing value from listing_data
                    initialData[field.key] = existingValue;
                } else {
                    // Use default value
                    initialData[field.key] = field.type === "Boolean" ? false : "";
                }
            });
        });
        setFormData(initialData);
        console.log("Initial form data with pre-populated values:", initialData);
    }, [formJsonData, property?.listing_info?.listing_data, property?.listing_data]);
    console.log("formJsonData", { formJsonData, formData });

    // Check if property object is valid (after all hooks)
    if (!property) {
        return (
            <div className="tw-p-10 tw-w-full tw-bg-background_color tw-pt-[70px] tw-flex tw-justify-center tw-items-center">
                <div className="tw-text-center">
                    <div className="tw-text-red-500 tw-text-xl tw-mb-4">⚠️</div>
                    <p className="tw-text-red-600">Property data is not available.</p>
                </div>
            </div>
        );
    }

    if (isLoading) {
        return (
            <div className="tw-p-10 tw-w-full tw-bg-background_color tw-pt-[70px] tw-flex tw-justify-center tw-items-center">
                <div className="tw-text-center">
                    <div className="tw-animate-spin tw-rounded-full tw-h-12 tw-w-12 tw-border-b-2 tw-border-primary tw-mx-auto tw-mb-4"></div>
                    <p className="tw-text-gray-600">Loading dynamic fields...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="tw-p-10 tw-w-full tw-bg-background_color tw-pt-[70px] tw-flex tw-justify-center tw-items-center">
                <div className="tw-text-center">
                    <div className="tw-text-red-500 tw-text-xl tw-mb-4">⚠️</div>
                    <p className="tw-text-red-600 tw-mb-4">{error}</p>
                    <button
                        onClick={() => window.location.reload()}
                        className="tw-bg-primary tw-text-white tw-px-4 tw-py-2 tw-rounded-lg hover:tw-bg-primary_hover"
                    >
                        Retry
                    </button>
                </div>
            </div>
        );
    }

    if (!formJsonData || formJsonData.length === 0) {
        return (
            <div className="tw-p-10 tw-w-full tw-bg-background_color tw-pt-[70px] tw-flex tw-justify-center tw-items-center">
                <div className="tw-text-center">
                    <div className="tw-text-gray-400 tw-text-4xl tw-mb-4">📋</div>
                    <p className="tw-text-gray-600 tw-text-lg">No dynamic fields available for this property.</p>
                    <p className="tw-text-gray-500 tw-text-sm tw-mt-2">Dynamic fields may not be configured for this property type or location.</p>
                </div>
            </div>
        );
    }

    if (!formData) {
        return (
            <div className="tw-p-10 tw-w-full tw-bg-background_color tw-pt-[70px] tw-flex tw-justify-center tw-items-center">
                <div className="tw-text-center">
                    <div className="tw-animate-spin tw-rounded-full tw-h-12 tw-w-12 tw-border-b-2 tw-border-primary tw-mx-auto tw-mb-4"></div>
                    <p className="tw-text-gray-600">Preparing form data...</p>
                </div>
            </div>
        );
    }
    const handleChange = (e, fieldKey) => {
        const { value, type, checked } = e.target;
        const newValue = type === "checkbox" ? checked : value;

        setFormData((prev) => ({
            ...prev,
            [fieldKey]: newValue,
        }));

        // Clear error when user starts typing
        if (formErrors[fieldKey]) {
            setFormErrors((prev) => ({
                ...prev,
                [fieldKey]: "",
            }));
        }
    };

    const handleDropdownChange = (value, fieldKey) => {
        setFormData((prev) => ({
            ...prev,
            [fieldKey]: value,
        }));
    };

    const handleCheckboxChange = (option, fieldKey, isChecked) => {
        setFormData((prev) => {
            const currentValues = prev[fieldKey] || [];
            const newValues = isChecked ? [...currentValues, option] : currentValues.filter((item) => item !== option);

            return {
                ...prev,
                [fieldKey]: newValues,
            };
        });
    };

    const validateForm = () => {
        const errors = {};
        let isValid = true;

        (formJsonData || []).forEach((section) => {
            (section?.fields || section?.sections || []).forEach((field) => {
                if (field.required && !formData[field.key]) {
                    errors[field.key] = `${field.label} is required`;
                    isValid = false;
                }
            });
        });

        setFormErrors(errors);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // if (validateForm()) {
        try {
            // Transform the form data into the required nested structure
            const payload = {};

            formJsonData.forEach((section) => {
                const sectionData = {};
                (section?.fields ?? section?.sections)?.forEach((field) => {
                    sectionData[field.label] = formData[field.key];
                });
                payload[section.name] = sectionData;
            });

            const response = await putApi(
                `/properties/update_property_listing_info/${property.property_id}`, // Assuming property has an id
                payload
            );
            if (response?.response?.data?.message) {
                toast.success(response?.response?.data?.message, { toastId: "success" });
            } else {
                toast.error(response?.error?.detail || "Failed to update property. Please try again.", { toastId: "success" });
            }
        } catch (error) {
            console.error("Error updating property:", error);
            // You might want to show an error message to the user
        } finally {
            setIsDynamicFieldsShow(false);
        }
        // }
    };

    const renderField = (field) => {
        if (!field.type) return;
        switch (field.type.toLowerCase()) {
            case "text":
            case "number":
            case "date":
                return (
                    <div key={field.key} className="tw-mb-4">
                        <label className="tw-block tw-text-[18px] tw-mb-1">
                            {field.required && <span className="tw-text-red-500">*</span>} {field.label}
                        </label>
                        <input
                            type={field.type ? field.type?.toLowerCase() : "text"}
                            value={formData[field.key] || ""}
                            onChange={(e) => handleChange(e, field.key)}
                            className={`tw-border tw-border-[#1A1A1A] tw-rounded-md tw-py-2 tw-px-3 tw-w-full ${formErrors[field.key] ? "tw-border-red-500" : ""}`}
                        />
                        {formErrors[field.key] && <p className="tw-text-red-500 tw-text-sm tw-mt-1">{formErrors[field.key]}</p>}
                        {field.help_text && <p className="tw-text-gray-500 tw-text-sm tw-mt-1">{field.help_text}</p>}
                    </div>
                );

            case "dropdown":
                return (
                    <div key={field.key} className="tw-mb-4">
                        <label className="tw-block tw-text-[18px] tw-mb-1">
                            {field.required && <span className="tw-text-red-500">*</span>} {field.label}
                        </label>
                        <select
                            value={formData[field.key] || ""}
                            onChange={(e) => handleDropdownChange(e.target.value, field.key)}
                            className={`tw-border tw-border-[#1A1A1A] tw-rounded-md tw-py-2 tw-px-3 tw-w-full ${formErrors[field.key] ? "tw-border-red-500" : ""}`}
                        >
                            <option value="">Select an option</option>
                            {(field.options || []).map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                        {formErrors[field.key] && <p className="tw-text-red-500 tw-text-sm tw-mt-1">{formErrors[field.key]}</p>}
                        {field.help_text && <p className="tw-text-gray-500 tw-text-sm tw-mt-1">{field.help_text}</p>}
                    </div>
                );

            case "boolean":
                return (
                    <div key={field.key} className="tw-mb-4 tw-flex tw-items-center">
                        <input
                            type="checkbox"
                            checked={formData[field.key] || false}
                            onChange={(e) => handleChange(e, field.key)}
                            className="tw-mr-2"
                        />
                        <label className="tw-text-[18px]">
                            {field.required && <span className="tw-text-red-500">*</span>} {field.label}
                        </label>
                        {field.help_text && <p className="tw-text-gray-500 tw-text-sm tw-mt-1">{field.help_text}</p>}
                    </div>
                );

            case "checkbox":
                return (
                    <div key={field.key} className="tw-mb-4">
                        <label className="tw-block tw-text-[18px] tw-mb-2">
                            {field.required && <span className="tw-text-red-500">*</span>} {field.label}
                        </label>

                        {/* Search input for checkbox options */}
                        <div className="tw-mb-3">
                            <input
                                type="text"
                                placeholder="Search options..."
                                value={searchTerms[field.key] || ""}
                                onChange={(e) =>
                                    setSearchTerms((prev) => ({
                                        ...prev,
                                        [field.key]: e.target.value,
                                    }))
                                }
                                className="tw-border tw-border-[#1A1A1A] tw-rounded-md tw-py-2 tw-px-3 tw-w-full"
                            />
                        </div>

                        <div className="tw-border tw-border-gray-200 tw-rounded-md tw-p-3 tw-max-h-[200px] tw-overflow-y-auto">
                            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 3xl:tw-grid-cols-3 tw-gap-2">
                                {(field.options || [])
                                    .filter((option) => option.toLowerCase().includes((searchTerms[field.key] || "").toLowerCase()))
                                    .map((option) => (
                                        <div key={option} className="tw-flex tw-items-start">
                                            <input
                                                type="checkbox"
                                                checked={(formData[field.key] || []).includes(option)}
                                                onChange={(e) => handleCheckboxChange(option, field.key, e.target.checked)}
                                                className="tw-mr-2 tw-mt-1"
                                            />
                                            <label className="tw-text-[14px]">{option}</label>
                                        </div>
                                    ))}
                            </div>
                        </div>

                        {formErrors[field.key] && <p className="tw-text-red-500 tw-text-sm tw-mt-1">{formErrors[field.key]}</p>}
                        {field.help_text && <p className="tw-text-gray-500 tw-text-sm tw-mt-1">{field.help_text}</p>}
                    </div>
                );

            default:
                return (
                    <div key={field.key} className="tw-mb-4">
                        <label className="tw-block tw-text-[18px] tw-mb-1">
                            {field.required && <span className="tw-text-red-500">*</span>} {field.label}
                        </label>
                        <input
                            type="text"
                            value={formData[field.key] || ""}
                            onChange={(e) => handleChange(e, field.key)}
                            className={`tw-border tw-border-[#1A1A1A] tw-rounded-md tw-py-2 tw-px-3 tw-w-full ${formErrors[field.key] ? "tw-border-red-500" : ""}`}
                        />
                        {formErrors[field.key] && <p className="tw-text-red-500 tw-text-sm tw-mt-1">{formErrors[field.key]}</p>}
                        {field.help_text && <p className="tw-text-gray-500 tw-text-sm tw-mt-1">{field.help_text}</p>}
                    </div>
                );
        }
    };

    return (
        <div className="tw-p-10 tw-w-full tw-bg-background_color tw-pt-[70px]">
            <form onSubmit={handleSubmit}>
                {formJsonData.map((section) => (
                    <div key={section.name} className="tw-mb-8">
                        <div className="tw-bg-[#E0ECF9] tw-p-3 tw-mt-5 tw-rounded-md tw-w-full tw-text-black tw-text-[20px] tw-font-[600]">
                            {section.name}
                        </div>
                        <div className="tw-mt-3 tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-6">
                            {(section?.fields || section?.sections)?.map((field) => renderField(field))}
                        </div>
                    </div>
                ))}

                <div className="tw-mt-8 tw-flex tw-justify-end">
                    <button type="submit" className="tw-bg-primary tw-text-white tw-py-2 tw-px-6 tw-rounded-md tw-text-[18px] hover:tw-bg-primary-hover">
                        Save Form
                    </button>
                </div>
            </form>
        </div>
    );
}
